import React from 'react';
import { DivProps } from '@monorepo/ui-kit';
import styles from './index.module.css';

const Hint = ({ className = '', children, ...props }: DivProps) => (
  <div className={`${className} ${styles.hint}`} {...props}>
    {children}
  </div>
);

export default Hint;
